const GetContractsUrl = (id: number) => `/admin/api/temp_workers/${id}/contracts`;

export { GetContractsUrl };